import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Map } from 'react-kakao-maps-sdk';
import BtnMapRefresh from './BtnMapRefresh';
import { Cluster, Coordinates, SearchShop } from '@remodeling/shop';
import MapButtons from './MapButtons';
import { SOUTH_KOREA_LEVEL_MAX } from '@/constants';
import ClusterBox from './ClusterBox';
import Marker from '@/ui/Marker';
import TrackingService from '@/services/tracking';

export interface KakaoMapProps {
  level: number;
  center: Coordinates;
  markerListApiData?: SearchShop[];
  // isCommonMainShop: boolean;
  isShowReSearchButton: boolean;
  clusterListApiData?: Cluster[];
  // markerTotalCount: number | undefined;
  // currentMarker?: Coordinates;
  hoverItem: number | null;
  setHoverItem: (num: number | null) => void;
  setLevel: (level: number) => void;
  handleChangeCenter: (map: any) => void;
  handleClickReSearchButton: () => void;
  // handleClickMoreMapButton: () => void;
  handleClickCluster: (coordinates: Coordinates) => void;
  handleClickCurrentLoactionButton: () => void;
  // handleGoToShopDetailPage: (shopId: number) => void;
}

const KakaoMap = forwardRef<HTMLDivElement, KakaoMapProps>(function KakaoMap(
  {
    level,
    center,
    // currentMarker,
    // totalPage,
    // currentPage,
    clusterListApiData,
    // markerTotalCount,
    markerListApiData,
    isShowReSearchButton,
    // isCommonMainShop,
    hoverItem,
    setHoverItem,
    setLevel,
    handleClickReSearchButton,
    // handleClickMoreMapButton,
    handleClickCurrentLoactionButton,
    handleClickCluster,
    handleChangeCenter,
  }: // handleGoToShopDetailPage,
  KakaoMapProps,
  ref,
) {
  const props = { ref };

  return (
    <MapContainer>
      <Map
        center={{
          lat: center?.latitude,
          lng: center?.longitude,
        }}
        style={{
          width: '100%',
          height: '100%',
        }}
        maxLevel={SOUTH_KOREA_LEVEL_MAX}
        level={level}
        onZoomChanged={(map) => setLevel(map.getLevel())}
        onCenterChanged={handleChangeCenter}
        {...props}
      >
        {level <= 10 &&
          markerListApiData?.map((item) => (
            <Marker
              key={item.id}
              item={item}
              hoverItem={hoverItem}
              setHoverItem={setHoverItem}
              {...TrackingService.tagGTM(
                'shop_search_shop_detail_marker_button',
                {
                  'shop-id': item.id,
                },
              )}
            />
          ))}
        {level >= 11 &&
          clusterListApiData?.map((item) => (
            <ClusterBox
              key={`${item.latitude}_${item.longitude}`}
              item={item}
              handleClickCluster={handleClickCluster}
              {...TrackingService.tagGTM('shop_search_cluster_button')}
            />
          ))}
      </Map>
      {isShowReSearchButton && level !== SOUTH_KOREA_LEVEL_MAX && (
        <BtnMapRefresh
          onClick={handleClickReSearchButton}
          {...TrackingService.tagGTM('shop_search_research_map_button')}
        />
      )}
      <MapButtons
        level={level}
        setLevel={setLevel}
        handleClickCurrentLoactionButton={handleClickCurrentLoactionButton}
      />
    </MapContainer>
  );
});

export default KakaoMap;

const MapContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: relative;
`;
